/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { UserId } from "../../commons/types/UserId";
import { SpaceSize } from "./SpaceSize";
import { GuestAuthenticationEnum } from "../../environments/types/GuestAuthenticationEnum";
import { InternalSpaceConfigBase } from "./InternalSpaceConfigBase";
export const Space = core.serialization
    .object({
    id: SpaceId,
    workbooksCount: core.serialization.number().optional(),
    filesCount: core.serialization.number().optional(),
    createdByUserId: UserId.optional(),
    createdByUserName: core.serialization.string().optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    expiredAt: core.serialization.date().optional(),
    lastActivityAt: core.serialization.date().optional(),
    guestLink: core.serialization.string().optional(),
    name: core.serialization.string(),
    displayOrder: core.serialization.number().optional(),
    accessToken: core.serialization.string().optional(),
    isCollaborative: core.serialization.boolean().optional(),
    size: SpaceSize.optional(),
    upgradedAt: core.serialization.date().optional(),
    guestAuthentication: core.serialization.list(GuestAuthenticationEnum),
    createdFrom: SpaceId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
})
    .extend(InternalSpaceConfigBase);
